/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-concat */
import Stack from "@mui/material/Stack";
import {
    CircularProgress,
    IconButton,
    Paper,
    Theme,
    Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { PreviewImage } from "../PreviewImage";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import React, { useContext, useRef } from "react";
import { Grid } from "@material-ui/core";
import { IUser } from "../../../../utils/UserInterfaces";
import { ConvertedDeviseWithMoneySign } from "../../../../utils/CurrencyConvertFunction";
import { CurrencyContext } from "../../../../contexts/AppContext";
import { FirstPageOutlined, Star } from "@material-ui/icons";
import RoomIcon from "@mui/icons-material/Room";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import CarRentalIcon from '@mui/icons-material/CarRental';
import { getDayNumberProm, useQuery } from "../../../../utils/App";
import { IAnnounce, IReview } from "../../../../utils/AnnounceInterfaces";
import { Link } from 'react-router-dom';
import { CountryService } from "../../../Admin/Countries/services/EquipmentCountry";
import { serverConfig } from "../../../../utils/config";
import { AnnouncesService } from "../../../Announces/services/AnnounceService";
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

// Add commission cache interface
interface CommissionCache {
    [key: string]: {
        percentage: number;
        timestamp: number;
    };
}

const COMMISSION_CACHE_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours

const useStyle = makeStyles((theme: Theme) => ({
    stackContainer: {
        cursor: "pointer",
        [theme.breakpoints.down("lg")]: {
            flexDirection: "column !important",
        },
    }, 
  
    txtPrice: {
        marginTop: 20,
        [theme.breakpoints.down("xs")]: {
            paddingTop: "5px !important",
        },
    },
    notes: {
        marginRight: 1,
        fontSize: 14,
        color: "#890608",
    },
    
    GridContainer: {
        width: "100% !important",
        height: "100% !important",
        background: "#ffff",
           
    },
     
    item: {
        cursor: 'pointer',
        marginBottom: theme.spacing(2),
    },

    pointe: {
        cursor: "pointer",
    },
    title: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 0,
        padding: 0,
        paddingTop: 16,
    },
    input: {
        "& > input": {
            padding: "10px 14px",
        },
    },
    btn: {
        fontSize: 16,
        fontFamily: "Josefin Sans",
        color: "#FFFFFF",
        textTransform: "capitalize",
        textAlign: "center",
        padding: "8px 14px",
        background: "#890608",
        "&:hover": {
            background: "#B5551B",
        },
    },
    stackButton: {
        position: "relative",
    },
    
    favButton: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    
    alignement: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    flexEnd: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    rate: {
        display: "flex",
        flexWrap: "wrap",
    },
    attributLogment: {
        display: "flex",
        alignItems: "center",
    },
    listAttribut: {
        fontFamily: "Josefin Sans !important",
        fontSize: "14px !important",
        background: "#EEBA41",
        padding: 6,
        borderRadius: 2,
        marginRight: "10px !important",
        "&:last-child": {
            marginRight: "0px !important",
        },
    },
    clickable: {
        cursor: "pointer",
    },
    videoIndicator: {
        position: 'absolute',
        top: 12,
        left: 12,
        backgroundColor: '#890608',
        color: 'white',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 14,
        zIndex: 1,
        display: 'flex',  
        alignItems: 'center', 
        gap: '4px'
    },
    imageContainer: {
        position: 'relative',
        height: '100%',
        width: '100%'
    }
}));

const countryMap: { [key: string]: string } = {
    cm: 'Cameroon',
    ga: 'Gabon',
    sn: 'Senegal',
    td: 'Chad',
    cg: 'Congo+Republic',
    ci: 'Cote+d%27Ivoire',
    ml: 'Mali',
    tg: 'Mogo',
    bj: 'Benin',
    ma: 'Morocco',
    tn: 'Tunisia',
    bf: 'Burkina faso',
    mr: 'Mauritania',
    mu: 'Mauritius',
    fr: 'France',
    ng: 'Nigeria',
    gh: 'Ghana',
    cf: 'Central+Africa+Republic',
    gq: 'Equatorial+Guinea',
    CM: 'Cameroon',
    GA: 'Gabon',
    SN: 'Senegal',
    TD: 'Chad',
    CG: 'Congo+Republic',
    CI: 'Cote+d%27Ivoire',
    ML: 'Mali',
    TG: 'Togo',
    BJ: 'Benin',
    MA: 'Morocco',
    TN: 'Tunisia',
    BF: 'Burkina+Faso',
    MR: 'Mauritania',
    MU: 'Mauritius',
    FR: 'France',
    NG: 'Nigeria',
    GH: 'Ghana',
    CF: 'Central+Africa+Republic',
    GQ: 'Equatorial+Guinea'
};

const searchTypeLabelMap = {
    apts: 'logements',
    htls: 'hotels',
    cars: 'voitures',
    rstt: 'immobilier',
    trs: 'circuits',
    evts: 'evenements',
};

interface DurationValues {
    trs_duration_days: number;
    trs_duration_hours: number;
    trs_duration_minutes: number;
}    

const useFormattedDuration = () => {
    const { t } = useTranslation<'common'>();

    return (values: DurationValues) => {
        const { trs_duration_days, trs_duration_hours, trs_duration_minutes } = values;

        const parts: string[] = [];
        if (trs_duration_days > 0) parts.push(`${trs_duration_days} ${t('propriete.units.day', { count: trs_duration_days })}`);
        if (trs_duration_hours > 0) parts.push(`${trs_duration_hours} ${t('propriete.units.hour', { count: trs_duration_hours })}`);
        if (trs_duration_minutes > 0) parts.push(`${trs_duration_minutes} ${t('propriete.units.minute', { count: trs_duration_minutes })}`);

        return parts.length ? parts.join(", ") : t('propriete.labels.no_duration_specified');
    };
};

const Env = serverConfig; 
const countryService = new CountryService();
const announceService = new AnnouncesService();
const SearchItemHome = (props: {
    data: any;
    onAddToFavorite: (itemId: string) => void;
    onRemoveToFavorite: (itemId: string) => void;
    isFav?: boolean;
    changingFav?: boolean;
    user?: IUser;
    searchTypeName: "cars" | "apts" | "htls" | "trs" | "evts" | "rstt";
    usage?: string;
    commissionFee?: number;
}) => {
    const {
        data,
        onAddToFavorite,
        onRemoveToFavorite,
        isFav,
        changingFav,
        user,
        searchTypeName,
        usage,
        commissionFee
    } = props;

    const classes = useStyle();
    const { t, i18n } = useTranslation<'common'>();
    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;
    const [loadingPrice, setLoadingPrice] = React.useState(false);
    const observerRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = React.useState(false);
    const [priceConverted, setPriceConverted] = React.useState<number>(0);
    const [displayPrice, setDisplayPrice] = React.useState<string>("");
    const commissionCacheRef = useRef<CommissionCache>({});

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { rootMargin: "200px", threshold: 0.1 }
        );

        const currentRef = observerRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    React.useEffect(() => {
        let isActive = true;
        
        const calculatePrices = async () => {
            setLoadingPrice(true);
            
            try {
                const hotelPercentage = commissionFee ?? 0;
              
                const totalPricePerJour = data.price;
                const normalTotalPrice = (
                    totalPricePerJour +
                    (totalPricePerJour * (hotelPercentage / 100)
                )).toFixed(2);
    
                // Convert currency
                const convertedValue = await ConvertedDeviseWithMoneySign(
                    data.devise, 
                    currency, 
                    Number(normalTotalPrice)
                );
                if (isActive) {
                    setDisplayPrice(convertedValue)
                    setPriceConverted(Number(convertedValue));
                }
            } catch (error) {
                console.error("Error calculating prices:", error);
            } finally {
                if (isActive) {
                    setLoadingPrice(false);
                }
            }
        };
    
        calculatePrices();

        return () => {
            isActive = false;
        };
    }, [
        currency,
        data,       
        commissionFee,
    ]);
    
    const formatDuration = useFormattedDuration();

    // Reverse the countryMap to get a map from country names to country codes
    const reverseCountryMap: { [key: string]: string } = Object.entries(countryMap)
        .reduce((acc, [code, name]) => {
            acc[name] = code;
            return acc;
        }, {} as { [key: string]: string });

    const countryName = data.property?.address?.country?.name ?? 'unknown-country';
    const countryId = data.property?.address?.country?._id ?? 'unknown-country';
    const cityId = data.property?.address?.city?._id;

    const city = data.property?.address?.city?.name;
    const qid = data._id;

    // Look up the country code using the country name
    const countryCode = reverseCountryMap[countryName] || countryName;

    // Ensure the city name is URL-friendly
    const formatUrlComponent = (str: string | undefined): string =>
        str ? str.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') : 'unknown';
    
    const cityName = city ? formatUrlComponent(city) : 'unknown-city';

    // Determine the search type label based on the searchTypeName prop
    const searchTypeLabel = searchTypeLabelMap[searchTypeName];

    // Format the photos array with proper URLs
    const formattedPhotos = data.property.photos.map((photo: any) => ({
        ...photo,
        filename: photo.filename,
        fileURL: `${Env.ApiRoot}/images/properties/${photo.filename}`,
    }));

    function isValidUrl(string?: string | null): boolean {
        if (!string) return false;
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }

    const url =
        usage === "hotelCarousel"
            ? `/details-announce-${data._id}`        
            : `/search?search_pays=${countryId}&search_adresse=${cityId}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${searchTypeName}&page=1&dci=&dco=&eqt=&click=&rooms=&qid=${qid}`;

    const announceType = data.property.type.name === "Appartement" 
            ? t("announce.AppartementMeublé") 
            : data.property.type.name === "Chambre" 
            ? t("announce.ChambreMeublée") 
            : data.property.type.name === "Maison" 
            ? t("announce.VillaMeublée") 
            : data.property.type.name === "Hôtel" 
            ? t("announce.EtablissementHotelier") 
            : data.property.type.name === "Suite" 
            ? t("announce.SuiteMeublée") 
            : data.property.type.name;

    // Check if video is available
    const hasVideo = isValidUrl(data.property?.address?.street);

    return (
        <Paper key={data._id} elevation={3} sx={{ overflow: 'hidden', borderRadius: 5 }}>
            <Stack direction="column" className={classes.stackContainer}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} className={classes.GridContainer}>                        
                        <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div style={{ 
                                height: "370px", 
                                overflow: "hidden",
                                position: 'relative'
                            }} ref={observerRef}>
                                {isVisible && (
                                    <div className={classes.imageContainer}>
                                        <PreviewImage
                                            photos={formattedPhotos}
                                            dealText=""
                                            isExeptional={false}
                                            data={data}
                                            ambassador={false}
                                            usage={usage}
                                        />
                                        {hasVideo && (
                                            <div className={classes.videoIndicator}>
                                                <PlayCircleFilledIcon style={{ fontSize: 16}} />
                                                {t('label.video_available')}
                                            </div>
                                        )}
                                        {user && (
                                            <IconButton
                                                className={classes.favButton}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    isFav ? onRemoveToFavorite(data._id) : onAddToFavorite(data._id);
                                                }}
                                            >
                                                {changingFav ? (
                                                    <CircularProgress size={24} />
                                                ) : isFav ? (
                                                    <Favorite style={{ color: '#890608' }} />
                                                ) : (
                                                    <FavoriteBorder style={{ color: '#ffffff' }} />
                                                )}
                                            </IconButton>
                                        )}
                                    </div>
                                )}
                            </div>
                        </a>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ height: "120px" }} // Reduced height since we removed reviews/ratings
                        className={classes.clickable}
                    >
                        <Stack
                            direction="column"
                            style={{
                                paddingTop: "10px",
                                paddingRight: "16px",
                                paddingBottom: "16px",
                                paddingLeft: "16px",
                            }}
                            flex={1}
                        >
                            <a href={url} target="_blank" rel="noopener noreferrer" className={classes.item} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div>
                                    {searchTypeName === "trs" && (
                                        <Typography fontFamily="Josefin Sans" marginTop="5px" marginBottom="5px"> {data.property.type.name}  </Typography>
                                    )}
                                    {searchTypeName === "htls" && (
                                        <Typography fontFamily="Josefin Sans" fontWeight='bold' fontSize='18px' marginBottom="5px" color="#890608" 
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}> 
                                        {data.property?.address?.zipcode || data.property?.hotel?.address?.zipcode}
                                        </Typography>
                                    )}
                                    <Typography 
                                        fontFamily="Josefin Sans" 
                                        fontWeight="bold" 
                                        marginTop={searchTypeName === "htls" ? "0px" : "5px"} 
                                        marginBottom={searchTypeName === "htls" ? "5px" : "10px"}
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    >
                                        {data.property.name}
                                    </Typography>                                
                                    {searchTypeName === "apts" || searchTypeName === "htls" ? (
                                        <Typography 
                                            fontFamily="Josefin Sans" 
                                            marginBottom={searchTypeName === "htls" ? "5px" : "10px"} 
                                            fontWeight="300" 
                                            style={{ 
                                            whiteSpace: 'nowrap', 
                                            overflow: 'hidden', 
                                            textOverflow: 'ellipsis' 
                                            }}
                                        >
                                            {searchTypeName === "htls" ? (
                                            `${data.property.rooms === 1
                                                ? `${data.property.rooms} ${t('announceRoom')}`
                                                : `${data.property.rooms} ${t('announceRooms')}`
                                            } · ${data.property.bathrooms === 1
                                                ? `${data.property.bathrooms} ${t("announceBathroom")}`
                                                : `${data.property.bathrooms} ${t("announceBathrooms")}`
                                            }`
                                            ) : (
                                            `${announceType} · ${
                                                data.property.rooms === 1
                                                ? `${data.property.rooms} ${t('announceRoom')}`
                                                : `${data.property.rooms} ${t('announceRooms')}`
                                            } · ${data.property.bathrooms === 1
                                                ? `${data.property.bathrooms} ${t("announceBathroom")}`
                                                : `${data.property.bathrooms} ${t("announceBathrooms")}`
                                            }`
                                            )}
                                        </Typography>                        
                                    ) : searchTypeName === "cars" ? (
                                        <Typography fontFamily="Josefin Sans" marginBottom="10px" fontWeight="300" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {`${announceType} · ${
                                                data.property.vhcl_passengers === 1
                                                ? `${data.property.vhcl_passengers} ${t('announcePassenger')}`
                                                : `${data.property.vhcl_passengers} ${t('announcePassengers')}`
                                            } · ${data.property.vhcl_doors === 1
                                                    ? `${data.property.vhcl_doors} ${t('announceDoor')}`
                                                    : `${data.property.vhcl_doors} ${t('announceDoors')}`
                                            } · ${data.property.vhcl_bags === 1
                                                    ? `${data.property.vhcl_bags} ${t("announceValise")}`
                                                    : `${data.property.vhcl_bags} ${t("announceValises")}`}`}    
                                        </Typography>
                                    ) : searchTypeName === "trs" ? (
                                        <>
                                            {(data?.property?.type?.name === "Circuit" || data?.property?.propertyTypeData?.[0]?.name === "Circuit") && (
                                                <>
                                                    <div>{data?.property?.trs_summary}</div> 
                                                    <span>&nbsp;|&nbsp;</span>
                                    
                                                    {(data?.property?.trs_duration_days || data?.property?.trs_duration_hours || data?.property?.trs_duration_minutes ||
                                                      data?.propertyData?.[0]?.trs_duration_days || data?.propertyData?.[0]?.trs_duration_hours || data?.propertyData?.[0]?.trs_duration_minutes) && (
                                                        <div style={{ marginTop: '4px' }}>
                                                            <span>
                                                                {formatDuration({
                                                                    trs_duration_days: data?.property?.trs_duration_days || data?.propertyData?.[0]?.trs_duration_days,
                                                                    trs_duration_hours: data?.property?.trs_duration_hours || data?.propertyData?.[0]?.trs_duration_hours,
                                                                    trs_duration_minutes: data?.property?.trs_duration_minutes || data?.propertyData?.[0]?.trs_duration_minutes
                                                                })}
                                                            </span>
                                                            <span>&nbsp;|&nbsp;</span>
                                                            <span>{data?.property?.trs_frequency || data?.propertyData?.[0]?.trs_frequency}</span>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                    
                                            {(data?.property?.trs_typeDeCuisine || data?.propertyData?.[0]?.trs_typeDeCuisine) && (
                                                <div style={{ marginBottom: '10px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <span style={{ fontWeight: 'bold' }}>Cuisine: </span>
                                                    {data?.property?.trs_typeDeCuisine || data?.propertyData?.[0]?.trs_typeDeCuisine}
                                                </div>
                                            )}
                                        </>                           
                                    ) :  null}

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <RoomIcon style={{ color: '#890608', fontSize: 20, marginRight: 3 }} />
                                        <Typography
                                            fontWeight="300"
                                            style={{
                                                fontFamily: 'Josefin Sans',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {searchTypeName === "apts" || searchTypeName === "htls" || searchTypeName === "rstt" || searchTypeName === "evts" || searchTypeName === "trs"? (
                                                <span>
                                                    {`${data.property.address.quartier} · ${
                                                        i18n.language === 'fr' ? data.property.address.city?.nomFR : data.property.address.city?.nomEN
                                                    } · ${
                                                        i18n.language === 'fr' ? data.property.address.country?.nomFR : data.property.address.country?.nomEN
                                                    }`}
                                                </span>
                                            ) : searchTypeName === "cars"  ? (
                                                <span>
                                                    {`${
                                                        i18n.language === 'fr' ? data.property.address.city?.nomFR : data.property.address.city?.nomEN
                                                    } · ${
                                                        i18n.language === 'fr' ? data.property.address.country?.nomFR : data.property.address.country?.nomEN
                                                    }`}
                                                </span>
                                            ) : null}
                                        </Typography>
                                    </div>

                                    {searchTypeName === "htls" && window.location.pathname.startsWith("/details-announce-") && (
                                        (displayPrice || (!isNaN(priceConverted) && priceConverted > 0) && (
                                            <div>
                                                <Typography 
                                                    fontFamily="Josefin Sans" 
                                                    fontWeight="bold" 
                                                    className={classes.txtPrice} 
                                                    style={{ textAlign: 'right' }}
                                                >
                                                    <b style={{ color: "#EA7606" }}>{displayPrice || priceConverted}</b>/{t("label.prix-nuit")}
                                                </Typography>
                                            </div>
                                        )
                                    ))}
                                </div>                                 
                            </a>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>
        </Paper>
    );
};

export default SearchItemHome;